import { useEffect, useState } from 'react';

export function useVerzoegert<T>(wert: T, ms = 250): T {
  const [v, setV] = useState(wert);
  useEffect(() => {
    const t = setTimeout(() => setV(wert), ms);
    return () => clearTimeout(t);
  }, [wert, ms]);
  return v;
}
